// (function(){
//     'use strict';
    
//     /*
//         JS Usage must follow:
//         jcu_js_v1.fn.functionName = function(){
//            //do things here 
//         }
//         jcu_js_v1.vars.variableName = "I am a variable";

//     */

//     jcu_js_v1.fn.search = {};
//     jcu_js_v1.vars.search = {};
//     jcu_js_v1.vars.search.wrapper = document.querySelector("#jcu-v1__search__async-wrapper");
//     jcu_js_v1.vars.search.scroll_to_top = true;

//     jcu_js_v1.fn.search.initSearchRows = function(){
//         var rows = document.querySelectorAll(".jcu-v1__search__result");
//         for(var i=0;i<rows.length;i++){
        
//             rows[i].addEventListener("click", function(e){
//                 if (e.target.className == 'jcu-v1__search__btn--toggle') {
//                     // console.log("Row btn clicked");   

//                     this.classList.contains("result-expanded") ? this.classList.remove("result-expanded") : this.classList.add("result-expanded");
//                     this.ariaExpanded === "true" ? this.ariaExpanded = "false" : this.ariaExpanded = "true"; 
//                 }
//             });
//         }
//     }

//     jcu_js_v1.fn.search.initSearchPagination = function(){
//         // console.log("Setting up Pagination buttons");
//         var refreshBtns = document.querySelectorAll(".jcu-v1__search__pagination .jcu-v1__search__btn");

//         if(refreshBtns){
//             for(var i=0;i<refreshBtns.length;i++){
//                 refreshBtns[i].addEventListener("click", function(e){
//                     e.preventDefault();
//                     jcu_js_v1.fn.search.updateSearchProps("start_rank", this.dataset.startrank);
//                 });
//             }
//         }

//     }

//     jcu_js_v1.fn.search.initSaveBtns = function(){

//         // Get Cookie name from result wrapper
//         var collection = jcu_js_v1.fn.search.getSearchProps("collection");

//         if(collection == "jcu-v1-this-is-uni") {
//             jcu_js_v1.vars.SearchCookie_name = "jcu-v1-this-is-uni-saved";
//         } else {
//             jcu_js_v1.vars.SearchCookie_name = "jcu_saved_courses";
//         }

//         var searchCookie = jcu_js_v1.fn.read_cookie(jcu_js_v1.vars.SearchCookie_name); 

//         // Gather all Save Btns, add EventListener and change state to Saved if id in cookie 
//         var saveBtn = document.querySelectorAll(".jcu-v1__search__btn--save");
//         for(var i=0;i<saveBtn.length;i++){

//             if (searchCookie && searchCookie.indexOf(saveBtn[i].dataset.assetid) > -1 ) {
//                 saveBtn[i].classList.add("result-saved")
//             }

//             saveBtn[i].addEventListener("click", function(e){
//                 e.preventDefault();
//                 var saveAssetID = this.dataset.assetid;
//                 // console.log("save btn clicked", saveAssetID);
//                 jcu_js_v1.fn.search.savePageCookie(saveAssetID);
//                 this.classList.contains("result-saved") ? this.classList.remove("result-saved") : this.classList.add("result-saved");

//                 // Run update Saved Courses Count Function for fixed buttons
//                 jcu_js_v1.fn.updateSavedCoursesCount();

//             });
//         };
        
//     }

    
//     jcu_js_v1.fn.search.savePageCookie = function($assetid) {

//         var collection = jcu_js_v1.fn.search.getSearchProps("collection");

//         if(collection == "jcu-v1-this-is-uni") {
//             jcu_js_v1.vars.SearchCookie_name = "jcu-v1-this-is-uni-saved";
//         } else {
//             jcu_js_v1.vars.SearchCookie_name = "jcu_saved_courses";
//         }
        

//         var searchCookie = jcu_js_v1.fn.read_cookie(jcu_js_v1.vars.SearchCookie_name); 
        
//         if (searchCookie == null) {
//             var arr = [];
//             arr.push($assetid);
//             jcu_js_v1.fn.bake_cookie(jcu_js_v1.vars.SearchCookie_name, arr);
//         } else {
//             //if id isnt in the array add it else remove it
//             if (searchCookie.indexOf($assetid) === -1) {
//                 searchCookie.push($assetid);
//             } else {
//                 var idx = searchCookie.indexOf($assetid);
//                 searchCookie.splice(idx, 1);
//             }
        
//             jcu_js_v1.fn.bake_cookie(jcu_js_v1.vars.SearchCookie_name, searchCookie);
//         }
//     }

//     // debounce from global.js 
//     jcu_js_v1.fn.search.refreshResults = jcu_js_v1.fn.debounce(function(){
//         // Async Refresh results, gather data from CCT metadata and generate Funnelback query URL

//         var searchWrapperEl = jcu_js_v1.vars.search.wrapper;
//         var searchUrl = searchWrapperEl.dataset.searchurl;

//         // Get Dataset Object String, convert to Object, convert to queryString
//         var params = JSON.parse(searchWrapperEl.dataset.search);
//         var queryString = Object.keys(params).map(key => key + '=' + params[key]).join('&');

//         // cosntruct final url to fetch
//         searchUrl = searchUrl + "?SQ_ASSET_CONTENTS_RAW&" + queryString;
//         // console.log("Search URL:", searchUrl);

//         // Enable Searching CSS
//         jcu_js_v1.fn.search.toggleSearching(true);

//         // If Post/Undergraduate checkbox is selected, change "showing.. " text accordingly 
//         if(params.meta_studyLevel_sand) {
//             jcu_js_v1.fn.search.updateSearchText(params.meta_studyLevel_sand);
//         } else {
//             jcu_js_v1.fn.search.updateSearchText();
//         }

//         // Build/Send Request for new results
//         var xhr = new XMLHttpRequest();
//         xhr.onload = function () {
//             if (xhr.status >= 200 && xhr.status < 300) {
//                 jcu_js_v1.fn.search.updateResultList(xhr.response);
//             } else {
//                 console.log('Failed to Gather new results');
//                 jcu_js_v1.fn.search.toggleSearching(false);
//             }
//         };
//         xhr.open('GET', searchUrl);
//         xhr.send();

//     }, 200);


//     jcu_js_v1.fn.search.updateResultList = function(response){
//         // console.log("Updating Results!");
        
//         jcu_js_v1.vars.search.wrapper.innerHTML = "";
//         jcu_js_v1.vars.search.wrapper.innerHTML = response;

//         jcu_js_v1.fn.search.initSearchPagination();
//         jcu_js_v1.fn.search.initSearchRows();
//         jcu_js_v1.fn.search.initSaveBtns();
//         jcu_js_v1.fn.search.toggleSearching(false);

//         // Scroll to top of Results block
//         if(jcu_js_v1.vars.search.scroll_to_top) {
//             jcu_js_v1.vars.search.wrapper.parentElement.scrollIntoView(true);
//         }
//     }

//     // Used to fade search results while ajax call is made, passed true/false as status
//     jcu_js_v1.fn.search.toggleSearching = function(status){
//         // console.log("Toggle searching", status);
//         if(status == true) {
//             jcu_js_v1.vars.search.wrapper.classList.add("loading-results");
//         } else if (status == false) {
//             jcu_js_v1.vars.search.wrapper.classList.remove("loading-results");
//         }
//     }

//     // Update "Showing ... courses text"
//     jcu_js_v1.fn.search.updateSearchText = function(searchType){
//         const textElem = document.querySelector(".jcu-v1__search__checks--location__text");
        
//         if(textElem){
//             if (searchType !== undefined) {
//                 textElem.innerText = "Showing " + searchType.toLowerCase().replace(/\s+/g, '') + " courses for "
//             } else {
//                 textElem.innerText = "Showing courses for "
//             }
//         }

//     }


//     jcu_js_v1.fn.search.initFormSubmit = function(){
//         var refreshForm = document.querySelector(".jcu-v1__search #jcu-v1-search__form");
//         if(refreshForm) {
//             refreshForm.addEventListener("submit", function(e){
//                 e.preventDefault();

//                 var inputValue = document.querySelector("#search-text-input").value || "!null";
//                 // Encode URL, replace Spaces(%20) with with +
//                 inputValue = encodeURIComponent(inputValue);
//                 inputValue = inputValue.replace(/%20/g, "+");

//                 // Delete start_rank to return to page 1
//                 jcu_js_v1.fn.search.deleteSearchProps("start_rank");

//                 // if Query value is !null, retain sort param, else delete for more accurate search
//                 if(inputValue == "!null"){

//                     // if sortMethod is stored, reapply to props 
//                     if(jcu_js_v1.vars.search.sortMethod){
//                         jcu_js_v1.fn.search.updateSearchProps("sort", jcu_js_v1.vars.search.sortMethod);
//                     }

//                 } else {
//                     // Store Sort method before deleting, only if not already stored
//                     if(!jcu_js_v1.vars.search.sortMethod){
//                         jcu_js_v1.vars.search.sortMethod = jcu_js_v1.fn.search.getSearchProps("sort");
//                     }
//                     // Remove sort prop
//                     jcu_js_v1.fn.search.deleteSearchProps("sort");
//                 }
                

//                 // Get new Results
//                 jcu_js_v1.fn.search.updateSearchProps("query", inputValue);
//             });
//         }
//     }

//     // Add Event Listeners to Checkbox Inputs to trigger page function and radio like functionality
//     // Seperate running of the function to set radio like functionality
//     const checkboxLevel = document.querySelectorAll('.jcu-v1__search__checks--level input[type="checkbox"]');
//     const checkboxLocation = document.querySelectorAll('.jcu-v1__search__checks--location input[type="checkbox"]');

//     jcu_js_v1.fn.search.initCheckbox = function(elements) {
    
//         for(var i=0;i<elements.length;i++) {
//             elements[i].addEventListener("change", function(){
                    
//                 if(this.checked == true) {
//                     for(var x=0;x<elements.length;x++) {
//                         elements[x].checked = false;
//                     };
//                     this.checked = true;
//                 }

//                 jcu_js_v1.fn.search.toggleSearching(true);
            
//                 var checkValue = this.value;
//                 // if checked is false, both checkboxes are not selected. Therefore, SearchProp is not required at all, therefore delete
//                 if(this.checked == false) {
//                     jcu_js_v1.fn.search.deleteSearchProps(this.dataset.key);
//                 } else {
//                     jcu_js_v1.fn.search.deleteSearchProps("start_rank");
//                     jcu_js_v1.fn.search.updateSearchProps(this.dataset.key, checkValue);
//                 }
            
//             });

            
//         }

//     }

//     // Usage: updateSearchProps("query", "education"); or updateSearchProps("num_ranks", 20);
//     jcu_js_v1.fn.search.updateSearchProps = function(key, value){

//         // Get Wrapper Elements' dataset of search params, and convert from string to object
//         var el = jcu_js_v1.vars.search.wrapper;
//         var data = el.dataset.search;
//         data = JSON.parse(data);
          
//         data[key] = value;
        
//         console.log("Search Data = ", data);
        
//         // Return to string and save as dataset.search
//         data = JSON.stringify(data);
        
//         el.dataset.search = data;

//         jcu_js_v1.fn.search.refreshResults();

//     }

//     jcu_js_v1.fn.search.getSearchProps = function(key){
//         var data = JSON.parse(jcu_js_v1.vars.search.wrapper.dataset.search)
//         var value = data[key];   
//         return value;
//     }

//     jcu_js_v1.fn.search.deleteSearchProps = function(key) {

//         var el = jcu_js_v1.vars.search.wrapper;
//         var data = el.dataset.search;
//         data = JSON.parse(data);
        
//         // Delete from Object
//         delete data[key];

//         // Return to string and save as dataset.search
//         data = JSON.stringify(data);
//         el.dataset.search = data;

//         jcu_js_v1.fn.search.refreshResults();
//     }

    
//     // Check for navigation to page using Browser's back button, set searchProps to match checkboxes selected, (bit hacky)
//     document.addEventListener("DOMContentLoaded", function(){
//         if (window.performance && window.performance.navigation.type === window.performance.navigation.TYPE_BACK_FORWARD) {
//             // Use Timeout to give the browser a moment to set inputs
//             // console.log("Page reached via Back Btn")
//             setTimeout(function () {                    
//                 // console.log("inside timeout");
//                 // Loop all inputs, if they are checked, run updateProps accordingly 
//                 var checkBtns = document.querySelectorAll(".jcu-v1__search__checks input");
//                 for(var i=0;i<checkBtns.length;i++){
//                     // console.log("inside for");
//                     if(checkBtns[i].checked) {
//                         // console.log("inside if", checkBtns[i]);
//                         var checkKey = checkBtns[i].dataset.key;
//                         var checkValue = checkBtns[i].value;
//                         jcu_js_v1.fn.search.updateSearchProps(checkKey, checkValue);
//                     }
//                 }
                
//             }, 625);
//         }
//     });



//     // Wrapped to prevent console errors
//     if(jcu_js_v1.vars.search.wrapper) {
//         // Send init Functions
//         jcu_js_v1.fn.search.initSaveBtns();
//         jcu_js_v1.fn.search.initSearchPagination();
//         jcu_js_v1.fn.search.initSearchRows();
//         jcu_js_v1.fn.search.initFormSubmit();
//         jcu_js_v1.fn.search.initCheckbox(checkboxLevel);
//         jcu_js_v1.fn.search.initCheckbox(checkboxLocation);
//     }

// }());
